/** @public */
export class AccountLessAuthClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async createChallenge(request, options) {
        const url = `${this.baseUrl}/api/v1/auth/create`;
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(request),
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
    async verifyChallenge(request, options) {
        const url = `${this.baseUrl}/api/v1/auth/verify`;
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(request),
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}
//# sourceMappingURL=account-less-auth-client.js.map